module.exports = __webpack_public_path__ + "img/car-3.1a512582.jpg";